import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
  getOrderNote,
  addNewOrderNote,
  getOrderNoteById,
  updateOrderNote,
  deleteOrderNote,
  clearOrderNoteNotify,
} from "../../store/order-note/actions";
import { getOrderVerifyTracking } from "store/actions";

import { Card, CardBody, Input } from "reactstrap";
import OrderVerityTrackingNoCheckBoxTable from "containers/order-verify-tracking/OrderVerityTrackingNoCheckBoxTable";

class OrderVerifyTrackingTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 10,
      modalAddIsOpen: false,
      modalEditIsOpen: false,
      modalConfirmDeleteIsOpen: false,
      orderId: props.orderId,
    };
  }

  componentDidMount() {
    const { orderId, getOrderVerifyTracking } = this.props;
    getOrderVerifyTracking({ orderId });
    this.setState({
      orderId,
    });
  }

  handleOnChangePage = page => {
    const { getOrderVerifyTracking } = this.props;
    const { orderId, pageSize } = this.state;
    getOrderVerifyTracking({ orderId, page, pageSize });
    this.setState({
      currentPage: page,
    });
  };

  handleOnPageSizeChange = size => {
    const { orderId, getOrderVerifyTracking } = this.props;
    getOrderVerifyTracking({ orderId, page: 1, pageSize: size });
    this.setState({ pageSize: size });
  };

  handleOnSearch = e => {
    const { orderId, getOrderVerifyTracking } = this.props;
    const { value } = e.target;
    getOrderVerifyTracking({ term: value ?? "", orderId });

    this.setState({
      term: value ?? "",
    });
  };

  render() {
    const { pageSize, currentPage } = this.state;
    const { items, itemCount, pageCount, loading } = this.props;
    return (
      <>
        <>
          <Card className="mb-2">
            <CardBody>
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <div className="search-box me-2 mb-2 d-inline-block">
                    <div className="position-relative">
                      <Input
                        type="text"
                        placeholder="Quick Search ..."
                        onChange={this.handleOnSearch}
                      ></Input>
                      <i className="fas fa-search search-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {items && (
                <Card>
                  <CardBody>
                    <OrderVerityTrackingNoCheckBoxTable
                      items={items}
                      itemCount={itemCount}
                      currentPage={currentPage}
                      totalPage={pageCount}
                      defaultPageSize={pageSize}
                      onChangePage={this.handleOnChangePage}
                      onPageSizeChange={this.handleOnPageSizeChange}
                    />
                  </CardBody>
                </Card>
              )}
            </>
          )}
        </>
      </>
    );
  }
}

OrderVerifyTrackingTab.propTypes = {
  message: PropTypes.object,
  items: PropTypes.array,
  item: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
  itemCount: PropTypes.number,
  pageCount: PropTypes.number,
  getOrderNote: PropTypes.func,
  getOrderNoteById: PropTypes.func,
  addNewOrderNote: PropTypes.func,
  updateOrderNote: PropTypes.func,
  deleteOrderNote: PropTypes.func,
  clearOrderNoteNotify: PropTypes.func,
  orderId: PropTypes.string,
  getOrderVerifyTracking: PropTypes.func,
};

const mapStateToProps = ({ orderVerifyTracking }) => {
  return orderVerifyTracking;
};

export default withRouter(
  connect(mapStateToProps, {
    getOrderNote,
    addNewOrderNote,
    getOrderNoteById,
    updateOrderNote,
    deleteOrderNote,
    clearOrderNoteNotify,

    getOrderVerifyTracking,
  })(OrderVerifyTrackingTab)
);
